import { create } from 'zustand';

// this is for the Breadcrump in future
export const useRouteNavigationStore = create((set) => ({
  lastRoute: {},
  actualRoute: {},

  setLastRouteVisited: (newRoute) => {
    set((state) => ({
      actualRoute: !state.actualRoute.location ? newRoute : state.actualRoute,
    }));
    set((state) => ({
      lastRoute:
        newRoute.location != state.actualRoute.location
          ? state.actualRoute
          : state.lastRoute,
    }));
    set((state) => ({
      actualRoute:
        newRoute.location != state.actualRoute.location
          ? newRoute
          : state.actualRoute,
    }));
    // the saving's order is important, do not change it
  },
}));
